import APIV2 from 'vue-lsi-util/APIAccesoV2'
import fechas from "vue-lsi-util/fechas";
import {servicecAWS} from "../helpers/uploadS3"

const choferes= {
  namespaced: true,

    state: {
      choferActual: {loggeado: false, nombre: '', numero: ''},
      fileUpload : null,
      nameFile : '',
      hashGenerate: ''
    },


    mutations: {
        actualizar(state, payload) {
            state.choferActual.loggeado=payload.loggeado
            if (payload.loggeado) {
                state.choferActual.numero=payload.numero
                state.choferActual.nombre=payload.nombre
            } else {
                state.choferActual.numero=""
                state.choferActual.nombre=""
            }
        },
        uploadFile(state, payload){
            state.fileUpload = payload
        },
        set_nameFile(state, payload) {
         state.nameFile = payload
        },
        set_hashGenerateNano(state, payload){
          state.hashGenerate = payload
      }
    },

    actions: {
        desloggear(state) {
            this.commit('choferes/actualizar', {loggeado: false})
            localStorage.removeItem("choferNumero")
            localStorage.removeItem("choferNombre")
        },

        actualizar(state, payload) {
            this.commit('choferes/actualizar', payload)
            if (payload.loggeado) {
                localStorage.choferNumero=payload.numero
                localStorage.choferNombre=payload.nombre
            } else {
                localStorage.removeItem("choferNumero")
                localStorage.removeItem("choferNombre")
            }
        },

        async registrarEntregaEntregada(Guia, NumeroChofer, fecha, estado, nombreReceptor) {
            return new Promise (
                function (resolve, reject) {

                    APIV2.acceder(
                        {
                            Cartel: "Registrando entrega ...",
                            Ruta: '/guia/'+Guia,
                            Body: {idChofer: NumeroChofer, fecha, estado, nombreReceptor},
                            Metodo: "PUT"
                        }
                    )
                    .then(data => {resolve(data)})
                    .catch(puteada => {reject(puteada)})
                }
            )
        },

      async registrarhashDocumentacionEntrega({state}, guia) {
        return new Promise (
          function (resolve, reject) {
            APIV2.acceder(
              {
                Ruta: `/guia/fotoDocumentacionEntrega/${guia}/${state.hashGenerate}`,
                Metodo: "PUT"
              }
            )
              .then(data => {resolve(data)})
              .catch(puteada => {reject(puteada)})
          }
        )
      },

        async getEntregasPendientes(NumeroChofer, Fecha) {
            return new Promise (
                function (resolve, reject) {
                    APIV2.acceder({Cartel: "Obteniendo ruta ...", Ruta: '/chofer/getEntregasFecha/'+NumeroChofer+"/"+Fecha})
                    .then(data => {resolve(data)})
                    .catch(puteada => {reject(puteada)})
                }
            )
        },

        async getByNumero(Numero) {
            return new Promise (
                function (resolve, reject) {
                    APIV2.acceder({Cartel: "Obteniendo datos del chofer ...", Ruta: '/chofer/'+Numero})
                    .then(data => {resolve(data)})
                    .catch(puteada => {reject(puteada)})
                }
            )
        },
       getHashByPhoto({state}, Id) {
        let fecha
        // if (process.env.NODE_ENV=="development") {
        //     fecha='2021-08-27'
        //   } else {
            fecha=fechas.getHoy()
          // }
        return new Promise (
          function (resolve, reject) {
            APIV2.acceder({
              Metodo:'PUT',
              Cartel: "Obteniendo información de registro...",
              Ruta: `/guia/getHashFotoNoEntregado/${Id}/${state.choferActual.numero}/${fecha}`
            })
              .then(async data => {
                resolve(data)
              })
              .catch(puteada => {reject(puteada)})
          }
        )
      },
      uploadFileToAws({state}){
        return new Promise (async (resolve, reject) => {
          try {
            const resultAWS = await servicecAWS.uploadToS3(state.fileUpload, state.nameFile)
            if (resultAWS) resolve(resultAWS)
          }catch (e) {
            reject(e)
          }
        })
      }
    },
}

export default choferes
